<template>
  <div class="container" :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_ROOT">
    <el-row v-if="esEdicion">
      <el-col :span="24">
        <div class="title">{{$t('PRESUPUESTO_pedido')}}</div>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :span="24">
        <div class="title">{{$t('PRESUPUESTO_nuevo_presupuesto')}}</div>
      </el-col>
    </el-row>

    <el-row>
      <!-- Datos Presupuesto -->
      <el-col class="container_col_1" :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
        <div class="contenedores">
          <el-card>
            <div v-if="inicializandoPresupuesto === true">
              <div class="loaderContainer">
                <el-icon class="is-loading"><Loading /></el-icon>
                <div class="text">{{ $t('PRESUPUESTO_inicializando_cabecera') }}</div>
              </div>
            </div>

            <div v-else class="card_body cabecera">
              <el-row type="flex" justify="end">
                <div class="idCabecera">ID: {{ presupuesto.id }}</div>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="subtitulo">{{ $t('PRESUPUESTO_numero_presupuesto') }}</div>
                  <div class="sub-title">{{ presupuesto.numero_presupuesto }}</div>
                </el-col>
              </el-row>

              <!--
              <el-row>
                <el-col :span="24">
                  <div class="sub-title">{{ presupuesto.nombre_empresa }} ({{presupuesto.clave}})</div>
                </el-col>
              </el-row>
              -->
              <el-row style="margin-bottom: 5px">
                <el-col :span="10">
                  <div class="label">{{ $t('PRESUPUESTO_razon_social') }}:</div>
                </el-col>
                <el-col :span="14" style="margin-top: 3px">
                  <el-input
                    :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_FIELD_RAZON_SOCIAL"
                    type="textarea"
                    autosize
                    :disabled="!permitirEditarLocal"
                    :placeholder="$t('PRESUPUESTO_razon_social_placeholder')"
                    size="small"
                    v-model="presupuesto.nombre_empresa "
                    @change="razonSocial"
                  />
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 5px">
                <el-col :span="10">
                  <div class="label">{{ $t('PRESUPUESTO_domicilio') }}:</div>
                </el-col>
                <el-col :span="14" style="margin-top: 5px">
                  <el-input
                    :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_FIELD_DOMICILIO"
                    type="textarea"
                    autosize
                    :disabled="!permitirEditarLocal"
                    :placeholder="$t('PRESUPUESTO_domicilio_placeholder')"
                    size="small"
                    v-model="presupuesto.domicilio"
                    @change="domicilio"
                  />
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PRESUPUESTO_instancia')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel" :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_FIELD_INSTANCIA">{{ descripcionInstancia }}</div>
                </el-col>
              </el-row>

              <el-row v-if="this.esEdicion">
                <el-col :span="10">
                  <div class="label">{{$t('PRESUPUESTO_ingresadoPor')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel" :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_FIELD_INGRESADO_POR">{{ presupuesto.ingresadoPor }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('GENERAL_fecha')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel" :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_FIELD_FECHA">{{presupuesto.fecha}}</div>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 10px">
                <el-col :span="10">
                  <div class="label">{{$t('PRESUPUESTO_vigencia')}}:</div>
                </el-col>
                <el-col :span="14" :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_FIELD_FECHA_VIGENCIA">
                  <el-date-picker
                    :disabled="!permitirEditarLocal"
                    style="width: 100%; margin-top: 3px"
                    v-model="presupuesto.fechaVigencia"
                    type="date"
                    size="small"
                    format="D/MM/YYYY"
                    suffix-icon="Calendar"
                    @change="fechaVigencia"
                  />
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PRESUPUESTO_nota_comercial')}}:</div>
                </el-col>
                <el-col :span="14">
                  <el-input
                    :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_FIELD_NOTA_COMERCIAL"
                    class="textarea"
                    type="textarea"
                    v-model="presupuesto.notaComercial"
                    :disabled="!permitirEditarLocal"
                    :rows="4"
                    @change="notaComercial"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="14">
                  <div class="label">{{$t('PRESUPUESTO_importe')}}:</div>
                </el-col>
                <el-col :span="10" class="moneda">
                  <div class="greyLabel" :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_FIELD_IMPORTES_EXPRESADOS_EN">{{presupuesto.moneda}}</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>

        <div v-if="permitirEditarLocal" class="btnContainer presupuesto">
          <div class="contenedores importacionDetalles">
            <div class="subtitulo">{{ $t('PRESUPUESTO_importar_subtitle') }}</div>

            <el-card>
              <div v-if="estadoProcesoImportacion === 0">
                <div class="label">
                  {{ $t('PRESUPUESTO_importar_msg') }}
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('PRESUPUESTO_importar_ejemplo_archivo')"
                    placement="top"
                  >
                    <el-icon style="cursor:pointer;" @click="dialogEjemploImportacion=true"><QuestionFilled /></el-icon>
                  </el-tooltip>
                </div>

                <div class="fileUploadContainer">
                  <FileUpload
                    name="importarDetallePresupuesto"
                    labelTag="PRESUPUESTO_importar_seleccione_btn"
                    :files="archivosDetallePresupuesto"
                    storeAction="presupuestos/uploadArchivoDetalles"
                    :temporalId="presupuesto.id"
                    :onFileListChange="onFileChanged"
                    :accept="',.xls,.xlsx'"
                    :limit="1"
                  />
                </div>

                <div v-if="archivosDetallePresupuesto.length > 0">
                  <el-button
                    type="primary"
                    size="small"
                    @click="importarDetalles"
                  >{{ $t('PRESUPUESTO_importar_importarBtn') }}</el-button>
                </div>
              </div>

              <div v-else-if="estadoProcesoImportacion === 1">
                <div class="loaderContainer">
                  <el-icon class="is-loading"><Loading /></el-icon>
                  <div class="text">{{ $t('PRESUPUESTO_importar_procesandoMsg') }}</div>
                </div>
              </div>

              <div v-else-if="estadoProcesoImportacion === 2">
                <div class="resultadoExportacion">
                  <div
                    class="filasProcesadas"
                  >{{ `${resultadoImportacion.FilasProcesadas} ${$t('PRESUPUESTO_importar_filasProcesadas')}` }}</div>
                  <div
                    class="filasExitosas"
                  >{{ `${resultadoImportacion.FilasProcesadas - resultadoImportacion.FilasConError} ${$t('PRESUPUESTO_importar_filasExitosas')}` }}</div>
                  <div class="filasConError">
                    {{ `${resultadoImportacion.FilasConError} ${$t('PRESUPUESTO_importar_filasConError')}` }}
                    <el-tooltip
                      v-if="resultadoImportacion.FilasConError > 0"
                      class="item"
                      effect="dark"
                      :content="$t('PRESUPUESTO_errores_importacion_titulo')"
                      placement="top"
                    >
                      <el-icon style="cursor:pointer;" @click="dialogErrorImportacion=true"><InfoFilled /></el-icon>
                    </el-tooltip>
                  </div>
                </div>

                <el-button
                  type="primary"
                  size="small"
                  @click="nuevaImportacionDetalles"
                >{{ $t('PRESUPUESTO_importar_nuevaImportacionBtn') }}</el-button>
              </div>
            </el-card>
          </div>
        </div>
      </el-col>

      <!-- Datos Productos y Detalles-->
      <el-col class="container_col_2" :xs="24" :sm="24" :md="17" :lg="17" :xl="17" :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_PRODUCTS_SECTION">
        <div class="contenedores">
          <el-card :body-style="{ padding: '0px' }">
            <div class="card_body">
              <div class="bordes_body">
                <el-row>
                  <el-col :span="20">
                    <div class="subtitulo">{{$t('PRESUPUESTO_productos_detalles_seleccionados')}}</div>
                  </el-col>
                  <el-col :span="4" class="contenedorIconos">
                    <el-col>
                      <div v-show="permitirEditarLocal" class="iconContainer" @click="agregarDetalle">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="$t('PRESUPUESTO_agregar_detalle')"
                          placement="top-start"
                        >
                          <el-icon><CirclePlus /></el-icon>
                        </el-tooltip>
                      </div>
                    </el-col>
                    <el-col>
                      <div v-show="permitirEditarLocal" class="iconContainer" @click="agregarProducto">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="$t('PRODUCTO_agregar')"
                          placement="top-start"
                        >
                          <el-icon><CirclePlus /></el-icon>
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
              </div>

              <el-row>
                <el-col :span="24">
                  <!-- Productos -->
                  <div class="card_list">
                    <div v-if="productos.length > 0">
                      <div
                        class="card_list_item"
                        v-for="(producto, index) in productos"
                        :key="index"
                      >
                        <ProductoSeleccionadoCard
                          :esVistaPedido = "esVistaPedido"
                          :esDetalle="false"
                          :permitirEditar="permitirEditarLocal" 
                          :producto="producto"
                          :esExento="esExento"
                          :pantallaOrigen="'Presupuesto'"
                          @datosPedido="actualizarDatosPresupuesto"
                          @eliminarProducto="eliminarProductoSeleccionado"
                          @cambiarEditar="cambiarEditar"
                          @datosPedidoManoObra="actualizarDatosPresupuestoManoObra"
                        />
                      </div>
                    </div>
                    <div v-if="detalles_presup.length > 0">
                      <div
                        class="card_list_item"
                        v-for="(detalle, index) in detalles_presup"
                        :key="index"
                      >
                        <ProductoSeleccionadoCard
                          :index="index"
                          :esDetalle="true"
                          :permitirEditar="permitirEditarLocal"
                          :producto="detalle"
                          :esExento="esExento"
                          :pantallaOrigen="'Presupuesto'"
                          @datosPedido="actualizarDatosPresupuesto"
                          @eliminarProducto="eliminarDetalleSeleccionado"
                          @cambiarEditar="cambiarEditar"
                          @modificarSubtotalDetalle="modificarSubtotalDetalleSeleccionado"
                        />
                      </div>
                    </div>
                    <div
                      v-if="productos.length == 0 && detalles_presup.length == 0"
                      class="loader"
                    >{{$t('PRESUPUESTO_agregar_producto_detalle')}}<el-icon><CirclePlus /></el-icon><el-icon><CirclePlus /></el-icon>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <!-- Detalle del presupuesto -->
              <div
                v-show="this.productos.length > 0 || this.detalles_presup.length > 0"
                class="detallePresupuesto"
              >
                <el-row>
                  <el-col :span="12">
                    <div class="blackLabel col1">{{$t('PRESUPUESTO_subtotal')}}</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blackLabel precio">{{ decimalToString(presupuesto.subtotal) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PRESUPUESTO_bonificacion')}}</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="label precio">{{ decimalToString(presupuesto.bonificacion) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PRESUPUESTO_porcentaje_descuento')}}</div>
                  </el-col>
                  <el-col :span="4">
                    <!-- <div class="label precio">{{porcentaje}}</div> -->
                    <div class="label precio">{{ presupuesto.descuentoPorcentaje }}%</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="label precio">{{ decimalToString(presupuesto.descuento) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PRESUPUESTO_intereses')}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="label precio">{{ presupuesto.interesPorcentaje }}%</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="label precio">{{ decimalToString(presupuesto.interesTotal) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="blackLabel col1">{{$t('PRESUPUESTO_neto')}}</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blackLabel precio">{{ decimalToString(presupuesto.neto) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PRESUPUESTO_iva')}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="label precio">{{ presupuesto.ivaPorcentaje }}%</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="label precio">{{ decimalToString(presupuesto.ivaTotal)}}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PRESUPUESTO_iva_reducido')}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="label precio">{{ presupuesto.ivaRedPorcentaje }}%</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="label precio">{{ decimalToString(presupuesto.ivaReducidoTotal) }}</div>
                  </el-col>
                </el-row>
              </div>

              <el-row class="total">
                <el-col :span="10">
                  <div
                    class="label col1"
                  >{{$t('PRESUPUESTO_importe_final')}} ({{ presupuesto.moneda }})</div>
                </el-col>
                <el-col :span="14 ">
                  <div class="label precio">{{ decimalToString(presupuesto.importeFinal) }} *</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>
        <el-row>
          <el-col
            :md="23"
            class="label leyenda precio"
          >*{{$t('PRESUPUESTO_sin_impuesto_ingresos_brutos')}}</el-col>
        </el-row>
        <div v-if="existeBaseDolar">
          <el-row >
            <el-col
              :md="23"
              class="label leyenda precio"
            >{{$t('PRESUPUESTO_referencia_base_dolar')}}</el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :md="24">
            <div class="btnContainer presupuesto">
              <el-button
                type="primary"
                icon="Check"
                v-if="sinEditar"
                :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_BUTTON_CONFIRM"
                @click="onConfirmarPresupuesto"
              >{{ $t('PRESUPUESTO_confirmarPresupuestoBtn') }}</el-button>
              <el-button
                type="primary"
                v-else-if="permitirEditarLocal"
                @click="save"
                :loading="guardado"
              >{{ $t('GENERAL_saveBtn') }}</el-button>
              <el-button
                type="primary"
                v-if="presupuesto.instanciaPresupuesto == '2A'"
                @click="volverAIngreso"
                :loading="guardado"
              >{{ $t('PRESUPUESTO_volverAIngresoBtn') }}</el-button>
              <el-button :data-testid="TEST_ID.PRESUPUESTOS.DETAIL_BUTTON_CANCEL" @click="cancelarPresupuesto">{{ $t('GENERAL_cancelBtn') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <AgregarProductoDialog
      :pantallaOrigen="'Presupuesto'"
      :visible="view_productos"
      :onClose="onCloseCancelar"
      :productosAgregados="productos"
      :detallesAgregados="detalles_presup"
      :subtotal="this.presupuesto.subtotal"
      @agregarProductosSeleccionados="agregarProductosSeleccionados"
      ref="dialogAgregarProducto"
    />

    <AgregarDetalleDialog
      :visible="view_detalles"
      :onClose="onCloseCancelarDetalle"
      @agregarDetalleIngresado="agregarDetalleIngresado"
      ref="dialogAgregarDetalle"
    />

    <AppDialog
      :visible="codigo_producto_a_eliminar !== undefined"
      :title="$t('PRODUCTO_eliminar')"
      :message="eliminar_producto_msg"
      :onClose="onCloseEliminarConfirmation"
    />
    <AppDialog
      :visible="codigo_detalle_a_eliminar !== undefined"
      :title="$t('DETALLE_eliminar')"
      :message="eliminar_detalle_msg"
      :onClose="onCloseEliminarConfirmationDetalle"
    />

    <AppDialog
      :visible="this.cancelar"
      :title="$t('GENERAL_desea_cancelar')"
      :message="cancelar_msg"
      :onClose="onCloseCancelarConfirmation"
    />

    <!-- Ejemplo de importacion -->
    <el-dialog
      :title="$t('PRESUPUESTO_importar_ejemplo_titulo')"
      v-model="dialogEjemploImportacion"
      width="25%"
    >
      <div>
        <el-row style="text-align:center !important;">
          <img style="width:100%" src="../../images/ejemplo_importacion.png" />
        </el-row>
        <el-row>
          <div class="label">{{$t('PRESUPUESTO_importar_ejemplo_indicaciones')}}</div>
        </el-row>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogEjemploImportacion = false">{{$t('GENERAL_acceptBtn')}}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- Errores de importacion -->
    <el-dialog
      :title="$t('PRESUPUESTO_errores_importacion_titulo')"
      v-model="dialogErrorImportacion"
      width="50%"
      top="1vh"
    >
      <!-- Tablas -->

      <el-table
        class="nuevo-presupuesto"
        :data="this.listC"
        style="width: 100%; max-height:400px"
        :header-cell-style="tableHeaderColor"
        height="210"
      >
        <el-table-column prop="error" label="Detalles de error"></el-table-column>
      </el-table>

      <div>
        <el-table
          v-if="this.listB.length > 0"
          class="label"
          ref="multipleTable"
          :header-cell-style="tableHeaderColor"
          :data="this.listB"
          style="width: 100%;  max-height:400px"
          height="210"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column property="Clave" label="Producto" width="120"></el-table-column>
          <el-table-column property="Leyenda" label="Detalles" min-width="350"></el-table-column>
          <el-table-column property="Cantidad" label="Cantidad" width="80"></el-table-column>
        </el-table>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-row>
            <el-col :xs="12" :sm="19" :md="19" :lg="19" :xl="19">
              <el-button
                type="primary"
                @click="listB.length > 0? dialogError():(dialogErrorImportacion = false)"
                :style="listB.length > 0?'font-size:70%':''"
              >{{$t(listB.length > 0?'GENERAL_agregar_continuar':'GENERAL_acceptBtn')}}</el-button>
            </el-col>
            <el-col :xs="12" :sm="3" :md="3" :lg="3" :xl="3">
              <el-button @click="dialogErrorImportacion = false">{{ $t('GENERAL_cancelBtn') }}</el-button>
            </el-col>
          </el-row>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ProductoSeleccionadoCard from "@/components/Cards/productoSeleccionadoCard";
import AgregarProductoDialog from "../Dialog/agregarProducto";
import AgregarDetalleDialog from "../Dialog/agregarDetalle";
import FileUpload from "../FileUpload/index";
import AppDialog from "../Dialog";
import { mapState } from "vuex";
import { showError, showSuccess } from "../Mensaje";
import { mostrarMensajeInternacionalizado } from "../MensajeInternacionalizado";
import { decimalToString } from "../Helpers/commonFunctions";
import TEST_ID from "@/testIds.json";

export default {
  name: "AltaPresupuesto",
  components: {
    ProductoSeleccionadoCard,
    AgregarProductoDialog,
    AgregarDetalleDialog,
    AppDialog,
    FileUpload
  },
  props: {
    permitirEditar: Boolean
  },
  data() {
    return {
      TEST_ID,
      plazosPago: [],
      productos: [],
      detalles_presup: [],

      inicializandoPresupuesto: true,
      presupuesto: {
        id: 0,
        instanciaPresupuesto: "",
        numero_presupuesto: 0,
        fecha: `${new Date().getDate()}/${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${new Date().getFullYear()}`,
        plazoDePago: undefined,
        clavePlazo: undefined,
        numero: 0,
        ingresadoPor: undefined,
        notaComercial: "",
        interes_porcentaje: 0,
        moneda: undefined,
        exentoIVA: false,
        subtotal: 0,
        descuento: 0,
        bonificacion: 0,
        descuentoPorcentaje: 0,
        interesPorcentaje: 0,
        interesTotal: 0,
        ivaPorcentaje: 21.0,
        ivaTotal: 0,
        ivaRedPorcentaje: 10.5,
        ivaReducidoTotal: 0,
        importeFinal: 0,
        neto: 0,
        clave: undefined,
        fechaVigencia: new Date(),
        fechaVigenciaCast: undefined,
        nombre_empresa: "",
        domicilio: ""
      },

      detalles: undefined,
      listB: [],
      listC: [],
      listRC: [],
      checkProducto: {
        B: []
      },

      esExento: false,

      cancelar_msg: "",
      cancelar: false,

      loading: false,
      view_productos: false,
      view_detalles: false,
      codigo_producto_a_eliminar: undefined,
      codigo_detalle_a_eliminar: undefined,
      eliminar_producto_msg: "",
      eliminar_detalle_msg: "",
      datosProductoActualizar: undefined,
      producto_a_eliminar: undefined,
      detalle_a_eliminar: undefined,
      esEdicion: false,
      guardado: false,
      sinEditar: false,

      // importaci�n de archivos
      archivosDetallePresupuesto: [],
      estadoProcesoImportacion: 0,
      resultadoImportacion: undefined,
      erroresImportacion: undefined,
      dialogEjemploImportacion: false,
      dialogErrorImportacion: false,
      promises: [],
      permitirEditarLocal: this.permitirEditar
    };
  },
  watch: {
    permitirEditar(val) {
      this.permitirEditarLocal = val;
    }
    /*
    productosManoObra() {
      this.sinEditar = false;
      this.presupuesto.descuentoPorcentaje = 0;
      this.presupuesto.interesPorcentaje = 0;
      this.presupuesto.clavePlazo = this.presupuesto.plazoDePago;



      this.productos.forEach(producto => {
            let datosProducto = {
              Cantidad: producto.Cantidad,
              precioUnitario: producto.Precio,
              IVA: producto.IVA,
              BonificacionImporte:
                producto.BonificacionPorcentaje * producto.Precio,
              BonificacionPorcentaje: producto.BonificacionPorcentaje,
              ManoObra: producto.ManoObra,
              ManoObraChecked: producto.ManoObraChecked
            };
            
            this.actualizarDatosPresupuesto(datosProducto);
          });
    }
    */
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario
    }),
    descripcionInstancia() {
      let descripcion = "";

      switch (this.presupuesto.instanciaPresupuesto) {
        case "0P":
          descripcion = this.$t("PRESUPUESTO_instancia_ingresado");
          break;

        case "ZP":
          descripcion = this.$t("PRESUPUESTO_instancia_historico");
          break;

        default:
          descripcion = "";
      }

      return `(${this.presupuesto.instanciaPresupuesto}) ${descripcion}`;
    },
    existeBaseDolar: function() {
      let flag = false;
      this.productos.forEach(producto => {
        if (producto.Moneda != "")
          flag = true;
      });

      return flag;
    }
  },

  methods: {
    decimalToString: decimalToString,
    init() {
      if (this.$route.params.id) {
        // indico que es una edici�n de Presupuesto
        this.esEdicion = true;
        // busco el Presupuesto a editar
        this.$store
          .dispatch("presupuestos/getPresupuesto", {
            id: this.$route.params.id,
            idUsuario: this.idUsuario
          })
          .then(data => {
            if (data.CodigoResultado === 0) {
              var presupuesto = JSON.parse(data.Datos);
              this.cargarPresupuesto(presupuesto);
            } else {
              mostrarMensajeInternacionalizado(
                data.CodigoResultado,
                data.DescripcionResultado
              );
            }
          })
          .finally(() => {
            this.loading = false;
            this.inicializandoPresupuesto = false;
          });
      } else {
        // indico que se est� inicializando el presupuesto
        this.inicializandoPresupuesto = true;

        // nuevo presupuesto
        this.$store
          .dispatch("presupuestos/iniciarPresupuesto", {
            idUsuario: this.idUsuario
          })
          .then(data => {
            if (data.CodigoResultado === 0) {
              // inicializo la cabecera del presupuesto
              let cabecera = JSON.parse(data.Datos);
              this.presupuesto.id = cabecera.Id;
              this.presupuesto.clave = cabecera.Clave;
              this.presupuesto.numero_presupuesto = cabecera.Numero;
              this.presupuesto.nombre_empresa = cabecera.Empresa;
              this.presupuesto.instanciaPresupuesto = cabecera.Instancia;
              this.presupuesto.plazoDePago = "*1";
              this.plazosPago = ["*1"];
              this.presupuesto.notaComercial = cabecera.NotaComercial;
              this.presupuesto.exentoIVA = cabecera.ExentoIva;
              this.esExento = cabecera.ExentoIva;
              if (cabecera.FechaVigencia == null) {
                this.setFechaVigencia();
              } else {
                this.presupuesto.fechaVigencia = cabecera.FechaVigencia;
              }
              if (cabecera.Moneda != null)
                this.presupuesto.moneda = cabecera.Moneda;
              else this.presupuesto.moneda = "ARS";
              this.presupuesto.interes_porcentaje = cabecera.InteresPorcentaje;
            } else {
              mostrarMensajeInternacionalizado(
                data.CodigoResultado,
                data.DescripcionResultado
              );
            }
          })
          .catch(error => {
            const responseData = error && error.response && error.response.data;
            const descripcion = typeof responseData === "string"
              ? responseData
              : responseData && responseData.DescripcionResultado;

            mostrarMensajeInternacionalizado(-1, descripcion);
          })
          .finally(() => {
            this.inicializandoPresupuesto = false;
          });
      }
    },
    setFechaVigencia() {
      let fecha = this.presupuesto.fechaVigencia;
      this.presupuesto.fechaVigencia.setDate(fecha.getDate() + 7);
    },
    agregarProducto() {
      this.view_productos = true;
      this.sinEditar = false;
    },

    agregarDetalle() {
      this.view_detalles = true;
      this.sinEditar = false;
    },

    handleSelectionChange(val) {
      this.checkProducto.B = val;
    },

    dialogError() {
      let productosB = this.checkProducto.B;
      this.agregarProductosSeleccionados(productosB);
      productosB.forEach(element => {
        this.eliminarProductoLista(element);
      });
      this.dialogErrorImportacion = false;
      this.checkProducto.B = [];
    },

    eliminarProductoLista(producto) {
      if (this.listB.length === 1) this.listB = [];
      else this.listB.splice(this.listB.indexOf(producto), 1);
      this.resultadoImportacion.FilasConError--;
    },

    agregarProductosSeleccionados(productos) {
      productos.forEach(element => {
        if (element.EsDetalle) {
          this.detalles_presup.push(element);
        }
        else {
          this.productos.push(element);
        }
      });
    },

    agregarDetalleIngresado(detalle) {
      this.detalles_presup.push(detalle);
    },

    onCloseCancelar(confirm) {
      // si confirm� el di�logo, guardo el presupuesto
      if (confirm) {
        this.savepresupuesto();
      }
      this.view_productos = false;
    },

    onCloseCancelarDetalle() {
      this.view_detalles = false;
    },

    cambiarEditar(sinEditar) {
      this.sinEditar = sinEditar;
    },

    notaComercial() {
      this.sinEditar = false;
    },
    razonSocial() {
      this.sinEditar = false;
    },
    domicilio() {
      this.sinEditar = false;
    },
    fechaVigencia() {
      this.sinEditar = false;
      let today = new Date();
      if (this.presupuesto.fechaVigencia <= today) {
        showError(this.$t("PRESUPUESTO_fecha_vigencia_incorrect"));
      }
      /*
      this.presupuesto.fechaVigenciaCast = `${this.presupuesto.fechaVigencia.getDate()}/${(this.presupuesto.fechaVigencia.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${this.presupuesto.fechaVigencia.getFullYear()}`;
          //console.log(this.presupuesto.fechaVigenciaCast);
      */
    },

    interes_porcentaje() {
      this.sinEditar = false;
      this.presupuesto.descuentoPorcentaje = 0;
      this.presupuesto.interesPorcentaje = 0;
      this.presupuesto.clavePlazo = this.presupuesto.plazoDePago;

      this.plazosPago.forEach(element => {
        if (element.Clave == this.presupuesto.plazoDePago) {
          if (element.Interes_Porcentaje >= 0) {
            this.presupuesto.interesPorcentaje = element.Interes_Porcentaje;
          } else
            this.presupuesto.descuentoPorcentaje =
              element.Interes_Porcentaje * -1;

          this.presupuesto.subtotal = 0;
          this.presupuesto.bonificacion = 0;
          this.presupuesto.ivaTotal = 0;
          this.presupuesto.ivaReducidoTotal = 0;

          this.productos.forEach(producto => {
            let datosProducto = {
              Cantidad: producto.Cantidad,
              precioUnitario: producto.Precio,
              IVA: producto.IVA,
              BonificacionImporte:
                producto.BonificacionPorcentaje * producto.Precio,
              BonificacionPorcentaje: producto.BonificacionPorcentaje,
              ManoObra: producto.ManoObra,
              ManoObraChecked: producto.ManoObraChecked
            };
            
            this.actualizarDatosPresupuesto(datosProducto);
          });
        }
      });
    },

    filtrar() {
      this.view_productos = false;
    },

    actualizarDatosPresupuesto(datosProducto) {
      //ACTUALIZA EL SUBTOTAL DEL PRESUPUESTO, SUMANDO O RESTANDO DEPENDIENDO DEL VALOR DE 'PRODUCTO.CantidadSeleccionada'
      //console.log(datosProducto);
      var subtotal;
      if(datosProducto.manoObraChecked == true){
        subtotal = datosProducto.Cantidad * (datosProducto.precioUnitario + datosProducto.ManoObra);
      }else{
        subtotal = datosProducto.Cantidad * datosProducto.precioUnitario;
      }
      //console.log(subtotal);
      this.presupuesto.subtotal += parseFloat(subtotal.toFixed(2));

      //Bonificacion Total
      var bonificacionRedond =
        datosProducto.Cantidad *
        datosProducto.precioUnitario *
        (datosProducto.BonificacionPorcentaje / 100);
      this.presupuesto.bonificacion += parseFloat(
        bonificacionRedond.toFixed(2)
      );

      //Bonifiacion por producto
      var bonificacion = parseFloat(
        (
          datosProducto.Cantidad *
          datosProducto.precioUnitario *
          (datosProducto.BonificacionPorcentaje / 100)
        ).toFixed(2)
      );

      //Inter�s Total
      this.presupuesto.interesTotal = parseFloat(
        (
          (this.presupuesto.subtotal - this.presupuesto.bonificacion) *
          (this.presupuesto.interesPorcentaje / 100)
        ).toFixed(2)
      );

      //Inter�s por producto
      var interes = parseFloat(
        (
          (datosProducto.Cantidad * datosProducto.precioUnitario -
            bonificacion) *
          (this.presupuesto.interesPorcentaje / 100)
        ).toFixed(2)
      );

      //Descuento Total
      this.presupuesto.descuento = parseFloat(
        (
          (this.presupuesto.subtotal - this.presupuesto.bonificacion) *
          (this.presupuesto.descuentoPorcentaje / 100)
        ).toFixed(2)
      );

      //Descuento por producto
      var descuento = parseFloat(
        (
          (datosProducto.Cantidad * datosProducto.precioUnitario -
            bonificacion) *
          (this.presupuesto.descuentoPorcentaje / 100)
        ).toFixed(2)
      );

      this.presupuesto.neto =
        this.presupuesto.subtotal -
        this.presupuesto.bonificacion -
        this.presupuesto.descuento +
        this.presupuesto.interesTotal;


      if(datosProducto.manoObraChecked == true){
              if (this.presupuesto.exentoIVA) {
                this.presupuesto.ivaTotal = 0;
                this.presupuesto.ivaReducidoTotal = 0;
              } else {
                if (datosProducto.IVA == 21.0)
                  this.presupuesto.ivaTotal += parseFloat(
                    (
                      (datosProducto.Cantidad * (datosProducto.precioUnitario + datosProducto.ManoObra) -
                        bonificacion -
                        descuento +
                        interes) *
                      (datosProducto.IVA / 100)
                    ).toFixed(2)
                  );
                else
                  this.presupuesto.ivaReducidoTotal += parseFloat(
                    (
                      (datosProducto.Cantidad * (datosProducto.precioUnitario + datosProducto.ManoObra) -
                        bonificacion -
                        descuento +
                        interes) *
                      (datosProducto.IVA / 100)
                    ).toFixed(2)
                  );
              }
      }else{
          if (this.presupuesto.exentoIVA) {
            this.presupuesto.ivaTotal = 0;
            this.presupuesto.ivaReducidoTotal = 0;
          } else {
            if (datosProducto.IVA == 21.0)
              this.presupuesto.ivaTotal += parseFloat(
                (
                  (datosProducto.Cantidad * datosProducto.precioUnitario -
                    bonificacion -
                    descuento +
                    interes) *
                  (datosProducto.IVA / 100)
                ).toFixed(2)
              );
            else
              this.presupuesto.ivaReducidoTotal += parseFloat(
                (
                  (datosProducto.Cantidad * datosProducto.precioUnitario -
                    bonificacion -
                    descuento +
                    interes) *
                  (datosProducto.IVA / 100)
                ).toFixed(2)
              );
          }
      }
      

      if (this.productos.length === 0 && this.detalles_presup.length === 0)
        this.presupuesto.importeFinal = 0;
      else
        this.presupuesto.importeFinal =
          this.presupuesto.neto +
          this.presupuesto.ivaTotal +
          this.presupuesto.ivaReducidoTotal;
    },


    actualizarDatosPresupuestoManoObra(datosProducto, oldValue) {
     console.log(oldValue);
     this.presupuesto.subtotal -= parseFloat(oldValue);
     this.presupuesto.subtotal += parseFloat(datosProducto.SubTotal.toFixed(2));

      //Bonificacion Total
      var bonificacionRedond =
        datosProducto.Cantidad *
        datosProducto.precioUnitario *
        (datosProducto.BonificacionPorcentaje / 100);
      this.presupuesto.bonificacion += parseFloat(
        bonificacionRedond.toFixed(2)
      );

      //Bonifiacion por producto
      var bonificacion = parseFloat(
        (
          datosProducto.Cantidad *
          datosProducto.precioUnitario *
          (datosProducto.BonificacionPorcentaje / 100)
        ).toFixed(2)
      );

      //Inter�s Total
      this.presupuesto.interesTotal = parseFloat(
        (
          (this.presupuesto.subtotal - this.presupuesto.bonificacion) *
          (this.presupuesto.interesPorcentaje / 100)
        ).toFixed(2)
      );

      //Inter�s por producto
      var interes = parseFloat(
        (
          (datosProducto.Cantidad * datosProducto.precioUnitario -
            bonificacion) *
          (this.presupuesto.interesPorcentaje / 100)
        ).toFixed(2)
      );

      //Descuento Total
      this.presupuesto.descuento = parseFloat(
        (
          (this.presupuesto.subtotal - this.presupuesto.bonificacion) *
          (this.presupuesto.descuentoPorcentaje / 100)
        ).toFixed(2)
      );

      //Descuento por producto
      var descuento = parseFloat(
        (
          (datosProducto.Cantidad * datosProducto.precioUnitario -
            bonificacion) *
          (this.presupuesto.descuentoPorcentaje / 100)
        ).toFixed(2)
      );

      this.presupuesto.neto =
        this.presupuesto.subtotal -
        this.presupuesto.bonificacion -
        this.presupuesto.descuento +
        this.presupuesto.interesTotal;

      if (this.presupuesto.exentoIVA) {
        this.presupuesto.ivaTotal = 0;
        this.presupuesto.ivaReducidoTotal = 0;
      } else {
        if (datosProducto.IVA == 21.0){
          this.presupuesto.ivaTotal -= parseFloat(
            (
              (oldValue -
                bonificacion -
                descuento +
                interes) *
              (datosProducto.IVA / 100)
            ).toFixed(2)
          );

          this.presupuesto.ivaTotal += parseFloat(
            (
              (datosProducto.SubTotal -
                bonificacion -
                descuento +
                interes) *
              (datosProducto.IVA / 100)
            ).toFixed(2)
          );
        }else{
          this.presupuesto.ivaReducidoTotal -= parseFloat(
            (
              (oldValue -
                bonificacion -
                descuento +
                interes) *
              (datosProducto.IVA / 100)
            ).toFixed(2)
          );

          this.presupuesto.ivaReducidoTotal += parseFloat(
            (
              (datosProducto.SubTotal -
                bonificacion -
                descuento +
                interes) *
              (datosProducto.IVA / 100)
            ).toFixed(2)
          );
        }
      }

      if (this.productos.length === 0 && this.detalles_presup.length === 0)
        this.presupuesto.importeFinal = 0;
      else
        this.presupuesto.importeFinal =
          this.presupuesto.neto +
          this.presupuesto.ivaTotal +
          this.presupuesto.ivaReducidoTotal;
    },

    cancelarPresupuesto() {
      if (this.idPresupuesto == 0) {
        let mensaje = this.$t("GENERAL_cancelar_mensaje");
        this.cancelar_msg = mensaje;
        this.cancelar = true;
      } else {
        this.$router.push({
          name: "Presupuestos",
          params: { keepFilter: true }
        });
      }
    },

    eliminarProductoSeleccionado(producto, datosProducto) {
      let mensaje = this.$t("PRODUCTO_eliminar_mensaje");
      mensaje = mensaje.replace("[codigo]", producto.Nombre);
      this.eliminar_producto_msg = mensaje;

      this.codigo_producto_a_eliminar = producto.Nombre;
      this.producto_a_eliminar = producto;
      this.datosProductoActualizar = datosProducto;
    },
    eliminarDetalleSeleccionado(producto, datosProducto) {
      let mensaje = this.$t("DETALLE_eliminar_mensaje");
      mensaje = mensaje.replace("[codigo]", producto.Clave);
      this.eliminar_detalle_msg = mensaje;

      this.codigo_detalle_a_eliminar = producto.Descripcion;
      this.detalle_a_eliminar = producto;

      this.datosProductoActualizar = datosProducto;
    },

    modificarSubtotalDetalleSeleccionado(index, subtotal) {
      this.detalles_presup[index].subtotal = subtotal;
    },

    onCloseEliminarConfirmation(confirm) {
      // si confirm� el di�logo, elimino
      if (confirm) {
        this.eliminarProducto();
      }

      // limpio los valores del di�logo
      this.codigo_producto_a_eliminar = undefined;
      this.eliminar_producto_msg = "";
    },

    onCloseEliminarConfirmationDetalle(confirm) {
      // si confirm� el di�logo, elimino
      if (confirm) {
        this.eliminarDetalle();
      }

      // limpio los valores del di�logo
      this.codigo_detalle_a_eliminar = undefined;
      this.eliminar_detalle_msg = "";
    },

    onCloseCancelarConfirmation(confirm) {
      // si confirm� el di�logo, elimino
      if (confirm) {
        this.$router.push({
          name: "Presupuestos",
          params: { keepFilter: true }
        });
      }

      // limpio los valores del di�logo
      this.cancelar = false;
      this.cancelar_msg = "";
    },

    eliminarProducto() {
      if (this.productos.length === 1) this.productos = [];
      else
        this.productos.splice(
          this.productos.indexOf(this.producto_a_eliminar),
          1
        );
      this.sinEditar = false;
      this.actualizarDatosPresupuesto(this.datosProductoActualizar);
    },

    eliminarDetalle() {
      if (this.detalles_presup.length === 1) {
        this.detalles_presup = [];
      } else {
        this.detalles_presup.splice(
          this.detalles_presup.indexOf(this.detalle_a_eliminar),
          1
        );
      }
      this.sinEditar = false;
      this.actualizarDatosPresupuesto(this.datosProductoActualizar);
    },

    cargarPresupuesto(presupuesto) {
      // cargo el presupuesto a editar
      // Datos presupuesto
      this.presupuesto.id = presupuesto.Id;
      this.presupuesto.clave = presupuesto.Clave;
      this.presupuesto.numero_presupuesto = presupuesto.Numero;
      this.presupuesto.instanciaPresupuesto = presupuesto.Instancia;
      this.presupuesto.ingresadoPor = presupuesto.CreadoPor;
      this.presupuesto.fecha = presupuesto.FechaStr;
      //this.presupuesto.plazoDePago = presupuesto.PlazoPago.Descripcion === "" ? undefined : presupuesto.PlazoPago.Descripcion;
      //this.presupuesto.clavePlazo = presupuesto.PlazoPago.Clave === "" ? undefined : presupuesto.PlazoPago.Clave;
      this.presupuesto.notaComercial = presupuesto.NotaComercial;
      this.presupuesto.nombre_empresa = presupuesto.Empresa;
      this.presupuesto.exentoIVA = presupuesto.ExentoIva;
      this.presupuesto.domicilio = presupuesto.Domicilio;
      this.presupuesto.fechaVigencia = presupuesto.FechaVigencia;
      if (presupuesto.Moneda != null)
        this.presupuesto.moneda = presupuesto.Moneda;
      else this.presupuesto.moneda = "ARS";

      // Detalle presupuesto
      if (this.permitirEditarLocal) {
        this.presupuesto.subtotal = 0;
        this.presupuesto.descuento = 0;
        this.presupuesto.bonificacion = 0;
        this.presupuesto.interesTotal = 0;
        this.presupuesto.ivaTotal = 0;
        this.presupuesto.ivaReducidoTotal = 0;
      } else {
        this.presupuesto.subtotal = presupuesto.Subtotal;
        this.presupuesto.descuento = presupuesto.DescuentoImporte;
        this.presupuesto.bonificacion = presupuesto.Bonificacion;
        this.presupuesto.interesTotal = presupuesto.InteresImporte;
        this.presupuesto.ivaTotal = presupuesto.IVAImporte;
        this.presupuesto.ivaTotal = presupuesto.IVAImporte;
        this.presupuesto.ivaReducidoTotal = presupuesto.IVAReducidoImporte;
        this.presupuesto.neto = presupuesto.ImporteNeto;
        this.presupuesto.importeFinal = presupuesto.ImporteTotal;
      }

      this.presupuesto.descuentoPorcentaje = presupuesto.DescuentoPorcentaje;
      this.presupuesto.interesPorcentaje = presupuesto.InteresPorcentaje;
      this.presupuesto.ivaPorcentaje = presupuesto.IVAPorcentaje;
      this.presupuesto.ivaRedPorcentaje = presupuesto.IVAReducidoPorcentaje;

      if (presupuesto.Instancia == "0P") this.sinEditar = true;

      // genero la misma estructura para los detalles de presupuesto y los cargo
      let detalles = presupuesto.Detalles.map(x => {
        return {
          ...x,
          Bonificacion: x.BonificacionPorcentaje,
          Nombre: x.Producto.Clave,
          Clave: x.Producto.Clave,
          Descripcion: x.Producto.Descripcion,
          EsDetalle: x.EsDetalle
        };
      });

      this.agregarProductosSeleccionados(detalles);
    },

    save() {
      // indico que se est� guardado el presupuesto
      this.guardado = true;
      // validaciones
      let valida = true;

      //obtenemos los productos y detalles para luego ingresarlos en el payload
      let detallesProductos;
      let detallesDetalles;
      detallesProductos = this.productos.map(x => {
        return {
          Id: x.Id || 0,
          ClaveProducto: x.Clave != undefined ? x.Clave : x.Producto.Clave,
          Cantidad: x.Cantidad,
          NotaTecnica: x.NotaTecnica || "",
          DescripcionProducto: x.Descripcion || "",
          PrecioUnitario: x.Precio,
          ManoObra: x.ManoObraChecked == true ? x.ManoObra : null
        };
      });
      detallesDetalles = this.detalles_presup.map(x => {
        return {
          Id: x.Id || 0,
          ClaveProducto: x.Clave,
          Cantidad: x.Cantidad,
          NotaTecnica: x.NotaTecnica || "",
          DescripcionProducto: x.Descripcion || "",
          PrecioUnitario: x.Precio,
          ManoObra: null
        };
      });
      console.log(detallesProductos);
      if (this.productos.length === 0 && this.detalles_presup.length === 0) {
        showError(this.$t("PRESUPUESTO_producto_missing"));
        valida = false;
      }

      if (this.presupuesto.domicilio == "") {
        showError(this.$t("PRESUPUESTO_domicilio_missing"));
        valida = false;
      }

      if (this.presupuesto.nombre_empresa == "") {
        showError(this.$t("PRESUPUESTO_razon_social_missing"));
        valida = false;
      }

      //Realizo una validacion contra: Fechas anteriores al dia actual
      //                               Fecha por defecto que viene de la bd 01/01/0001
      //                               Fecha que este null
      let today = new Date();

      if (this.presupuesto.fechaVigencia <= today) {
        showError(this.$t("PRESUPUESTO_fecha_vigencia_incorrect"));
        valida = false;
      }
      else if(this.presupuesto.fechaVigencia !== null){
        let defaultDateStr = "0001-01-01T00:00:00";
        let fechaVigenciaStr = this.presupuesto.fechaVigencia.toString();
        if (fechaVigenciaStr == defaultDateStr) {
        showError(this.$t("PRESUPUESTO_fecha_vigencia_incorrect"));
        valida = false;
        }
      }
      else if(this.presupuesto.fechaVigencia === null){
        showError(this.$t("PRESUPUESTO_fecha_vigencia_incorrect"));
        valida = false;
      }

      if (!valida) {
        this.guardado = false;
        return;
      }
      // armo el payload
      let payload = {
        IdUsuario: this.idUsuario,
        IdPresupuesto: this.presupuesto.id,
        //ClavePlazoPago: this.presupuesto.plazoDePago,
        Empresa: this.presupuesto.nombre_empresa,
        FechaVigencia: this.presupuesto.fechaVigencia,
        Domicilio: this.presupuesto.domicilio,
        NotaComercial: this.presupuesto.notaComercial,
        Detalles: detallesProductos.concat(detallesDetalles)
      };

      //if (this.esEdicion) payload.ClavePlazoPago = this.presupuesto.clavePlazo;
      // persisto el presupuesto
      this.$store
        .dispatch("presupuestos/savePresupuesto", payload)
        .then(data => {
          if (data.CodigoResultado === 0) {
            this.$router.push({
              name: "ConfirmarPresupuesto",
              params: { id: this.presupuesto.id }
            });
          } else {
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
          }
        })
        .finally(() => (this.guardado = false));
    },

    volverAIngreso() {
      // recupero el id del presupuesto
      let idPresupuesto = this.$route.params.id;

      //regreso el presupuesto a Ingresado
      this.$store
        .dispatch("presupuestos/volverAIngreso", { id: idPresupuesto })
        .then(data => {
          if (data.CodigoResultado === 0) {
            // indico que es una edici�n de presupuesto
            this.esEdicion = true;

            // busco el presupuesto a editar
            this.$store
              .dispatch("presupuestos/getPresupuesto", {
                id: this.$route.params.id,
                idUsuario: this.idUsuario
              })
              .then(response => {
                if (response.CodigoResultado === 0) {
                  var presupuesto = JSON.parse(response.Datos);
                  this.permitirEditarLocal = true;
                  this.presupuesto.instanciaPresupuesto = presupuesto.Instancia;
                  //Scroll para Android
                  document.body.scrollTop = 0;
                  //Scroll para IOS
                  document.documentElement.scrollTop = 0;
                  showSuccess(this.$t("PRESUPUESTO_success"));
                } else {
                  mostrarMensajeInternacionalizado(
                    data.CodigoResultado,
                    data.DescripcionResultado
                  );
                }
              })
              .finally(() => {
                this.loading = false;
                this.inicializandoPresupuesto = false;
              });
          } else {
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
          }
        });
    },
    onFileChanged(name, fileList) {
      this.archivosDetallePresupuesto = fileList;
    },
    importarDetalles() {
      // indico que se est� procesando el archivo
      this.estadoProcesoImportacion = 1;

      // llamo a la l�gica de procesamiento del archivo importado
      this.$store
        .dispatch("presupuestos/importarDetallesPresupuesto", {
          id: this.presupuesto.id,
          idUsuario: this.idUsuario
        })
        .then(async data => {
          if (data.CodigoResultado === 0) {
            // indico que se modifico el presupuesto
            this.sinEditar = false;
            // recupero las estad�sticas de la importaci�n
            let datos = JSON.parse(data.Datos);
            this.resultadoImportacion = datos.ResultadoImportacion;

            // genero la misma estructura para los detalles de presupuesto y los cargo
            this.detalles = datos.Detalles.map(x => {
              return {
                ...x,
                Nombre: x.Producto.Clave,
                Clave: x.Producto.Clave,
                Descripcion: x.Producto.Descripcion
              };
            });

            let productosAux = this.detalles.map(x => {
              return {
                Nombre: x.Nombre == undefined ? x.Producto.Clave : x.Nombre,
                Clave: x.Clave,
                Cantidad: x.Cantidad,
                Precio: x.Precio,
                IVA: x.IVA,
                BonificacionImporte:
                  x.BonificacionImporte == undefined
                    ? 0
                    : x.BonificacionImporte,
                BonificacionPorcentaje: x.BonificacionPorcentaje,
                UnidadMedida: x.UnidadMedida,
                AdmiteDecimales: x.AdmiteDecimales,
                Leyenda: x.Leyenda,
                EstadoVenta: x.EstadoVenta,
                Descripcion: x.Descripcion,
                Promocion: x.Promocion
              };
            });

            this.getErroresImportacion();

            for (const producto of productosAux) {
              // await this.validarEstadoVenta(producto);
              await this.validarEstadoVenta(producto);
            }

            this.estadoProcesoImportacion = 2;
          } else {
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
            this.nuevaImportacionDetalles();
          }
        });
    },
    getErroresImportacion() {
      if (this.resultadoImportacion.ErroresImportacion.length > 0) {
        this.erroresImportacion = this.resultadoImportacion.ErroresImportacion.map(
          error => {
            let RowNumber = error.split("|")[0];
            let Message = this.$t(
              "PRESUPUESTO_error_importar_" + error.split("|")[1]
            );
            if (RowNumber != "0")
              Message = Message.replace("[fila]", RowNumber);
            else Message = error.split("|")[1];
            this.listC.push({ error: Message });
            return Message;
          }
        );
      }
    },
    validarEstadoVenta(producto) {
      switch (producto.EstadoVenta) {
        case "B":
        case "C":
          if (producto.EstadoVenta == "B") {
            if (producto.Leyenda != "") {
              let aux = this.listB.filter(x => {
                return x.Clave == producto.Clave;
              });
              let aux2 = this.detalles.filter(x => {
                return x.Clave == producto.Clave;
              });
              if (aux.length > 0 || (aux.length > 0 && aux2.length > 1))
                producto.Leyenda = producto.Leyenda + " (REPETIDO)";
              this.listB.push(producto);
              this.resultadoImportacion.FilasConError++;
            } else {
              this.productoRepetido(producto);
            }
          } else {
            let aux = this.listRC.filter(x => {
              return x.Clave == producto.Clave;
            });
            let aux2 = this.detalles.filter(x => {
              return x.Clave == producto.Clave;
            });
            let mensaje = "";
            if (aux.length > 0 || (aux.length > 0 && aux2.length > 1))
              mensaje =
                producto.Clave + ": " + producto.Leyenda + " (REPETIDO)";
            else mensaje = producto.Clave + ": " + producto.Leyenda;
            this.listRC.push(producto);
            this.listC.push({ error: mensaje });
            this.resultadoImportacion.FilasConError++;
          }
          break;

        default:
          this.productoRepetido(producto);
          break;
      }
    },
    productoRepetido(producto) {
      let aux = this.productos.filter(x => {
        return x.Clave == producto.Clave;
      });
      let aux2 = this.detalles.filter(x => {
        return x.Clave == producto.Clave;
      });

      if (aux.length > 0 || (aux.length > 0 && aux2.length > 1)) {
        producto.Leyenda = "Repetido";
        this.listB.push(producto);
        this.resultadoImportacion.FilasConError++;
      } else {
        //Agregar a la lista de productos
        this.productos.push(producto);
      }
    },
    nuevaImportacionDetalles() {
      // inicializo las variables de importaci�n de detalles
      this.estadoProcesoImportacion = 0;
      this.archivosDetallePresupuesto = [];
      this.resultadoImportacion = undefined;
    },
    onConfirmarPresupuesto() {
      // indico que se est� confirmando el presupuesto
      this.estadoProcesoConfirmacion = 1;

      // recupero el id del presupuesto
      let idPresupuesto = this.$route.params.id;

      let tieneErrores = false;

      if (this.productos.length === 0 && this.detalles_presup.length === 0) {
        showError(this.$t("PRESUPUESTO_producto_missing"));
        tieneErrores = true;
      }

      if (this.presupuesto.domicilio == "") {
        showError(this.$t("PRESUPUESTO_domicilio_missing"));
        tieneErrores = true;
      }

      if (this.presupuesto.nombre_empresa == "") {
        showError(this.$t("PRESUPUESTO_razon_social_missing"));
        tieneErrores = true;
      }

      let today = new Date();
      let defaultDateStr = "0001-01-01T00:00:00";
      let fechaVigenciaStr = this.presupuesto.fechaVigencia.toString();
      //console.log("Fecha vigencia: "+fechaVigenciaStr);
      //console.log("default: "+ defaultDateStr);
      if (
        this.presupuesto.fechaVigencia <= today ||
        fechaVigenciaStr == defaultDateStr ||
        this.presupuesto.fechaVigencia == null
      ) {
        showError(this.$t("PRESUPUESTO_fecha_vigencia_incorrect"));
        tieneErrores = true;
      }

      if (tieneErrores) {
        // vuelvo al estado inicial de confirmaci�n
        this.estadoProcesoConfirmacion = 0;
        return;
      }

      // confirmo el presupuesto
      this.$store
        .dispatch("presupuestos/confirmarPresupuesto", { id: idPresupuesto })
        .then(data => {
          if (data.CodigoResultado === 0) {
            // indico que se confirm� el presupuesto
            this.estadoProcesoConfirmacion = 2;
            showSuccess(this.$t("PRESUPUESTO_confirmado_success"));
            this.$store
              .dispatch("presupuestos/getPresupuesto", {
                id: idPresupuesto,
                idUsuario: this.idUsuario
              })
              .then(data => {
                if (data.CodigoResultado === 0) {
                  var numero = JSON.parse(data.Datos).Numero;
                  // espero X milisegundos y contin�o con la ejecuci�n
                  setTimeout(
                    () =>
                      this.$router.push({
                        name: "Presupuestos",
                        params: { numeroPresupuesto: numero }
                      }),
                    3000
                  );
                } else {
                  mostrarMensajeInternacionalizado(
                    data.CodigoResultado,
                    data.DescripcionResultado
                  );
                }
              });
          } else {
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );

            // vuelvo al estado inicial de confirmaci�n
            this.estadoProcesoConfirmacion = 0;
          }
        });
    },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) {
        return {
          backgroundColor: "var(--main-color)",
          color: "#fff",
          fontWeight: "bold"
        };
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.idCabecera {
  color: gray;
  font-size: 10px;
  padding-bottom: 5px;
}
.el-icon-question {
  cursor: pointer;
}
.loaderContainer {
  text-align: center;
}

.loaderContainer i {
  font-size: 40px;
  color: var(--main-color);
}
.loaderContainer .text {
  font-size: 11px;
  margin-top: 5px;
  color: var(--main-color);
}
.loader {
  margin-left: 5%;
  color: #999;
}
.container {
  display: inline-block;
  padding: 0;
  width: 95%;
  margin: 0 auto;
}
.card_body {
  text-align: left;
}
.total {
  background-color: var(--main-color);
  color: #ffffff;
  font-weight: bold;
  padding: 0 20px 10px;
}
.blackLabel {
  text-align: left;
  margin: 12px 0 4px 15px;
  justify-content: center;
  font-weight: bold;
}
.el-divider {
  margin: 2px 0 2px 0;
}
.total .label {
  font-size: 1.5em;
}
.el-card__body {
  padding: 0px !important;
}
.contenedores {
  margin: 0px 20px 0 0;
}
.title {
  font-size: 24px;
  font-weight: bold;
  line-height: 26px;
  padding: 0 0 7px;
}
.subtitulo {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.cabecera .subtitulo {
  font-size: 16px;
}

.importacionDetalles .subtitulo {
  color: var(--main-color);
  margin-bottom: 5px;
}

.importacionDetalles button {
  width: 100%;
  margin-top: 20px;
}

.resultadoExportacion {
  font-size: 13px;
  font-weight: bold;
  text-align: center;
}

.resultadoExportacion .filasProcesadas {
  color: #2b47af;
  margin-bottom: 5px;
}

.resultadoExportacion .filasExitosas {
  color: #499c4d;
  margin-bottom: 5px;
}

.resultadoExportacion .filasConError {
  color: #f44336;
  margin-bottom: 10px;
}

.detallePresupuesto {
  background: rgba(233, 233, 233, 0.959);
  padding: 0 20px 10px;
}
.botonImportar {
  background: white;
  color: var(--main-color);
  border-color: var(--main-color);
}
.sub-title {
  padding: 3px 0px 10px 0px;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

.btnContainer.presupuesto {
  text-align: left;
  margin-top: 30px;
}
.label {
  font-size: 14px;
  text-align: left;
  padding: 10px 0px;
}
.label.col1 {
  margin-left: 15px;
  justify-content: center;
}
.greyLabel {
  color: #6b6b6b;
  font-weight: normal;
  padding: 10px 0px;
  text-align: left;
}
.input {
  box-sizing: border-box;
  display: inline-block;
  outline: 0;
}

.select,
.textarea {
  padding: 2px 0px;
  display: grid;
}

.textarea {
  border-radius: 4px;
  min-height: 90px;
}

.card_list {
  min-height: 60px;
  -webkit-flex-direction: column; /* Safari 6.1+ */
  display: flex;
  flex-direction: column;
}
.card_list_item {
  position: relative;
}
.card_list_item:nth-child(odd) {
  background: var(--main-color)1a;
}
.iconContainer {
  cursor: pointer;
  text-align: right;
}
.iconContainer .el-icon {
  cursor: pointer !important;
  font-size: 38px;
  color: var(--main-color);
  text-align: left;
  margin-bottom: 5px;
}
/* merged into .iconContainer .el-icon above */
.contenedorIconos {
  display: flex;
  justify-content: flex-end;
}
.bordes_body {
  padding: 20px 20px 10px;
}
.precio {
  text-align: right;
}
.leyenda {
  color: rgba(0, 0, 0, 0.644);
}
.detallePresupuesto .label {
  padding: 2px 0px;
}
.detallePresupuesto .blackLabel {
  margin: 0 0 0 15px;
  padding: 3px 0px;
}
@media (max-width: 600px) {
  .card_list {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
  .title {
    margin: 0px;
  }
}

@media (max-width: 1200px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 1;
    width: 100% !important;
  }
  .container_col_2 {
    flex: 1;
    width: 100% !important;
    margin-top: 20px;
  }
  .btnContainer.presupuesto {
    text-align: center;
    margin-top: 20px;
  }
}
</style>

<style>
.btnContainer.presupuesto.hidden-md-and-up {
  text-align: left;
  margin-bottom: 10px;
}
.btnContainer.presupuesto.hidden-md-and-up .botonImportar {
  padding: 5px 5px !important;
}

.el-table .nuevo-presupuesto th > .cell {
  color: #000000 !important;
}
</style>

